export default __webpack_public_path__ + "static/media/36_C.96873b1e.svg";